import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FileStatusButton, FileStatusPanelItem, FileStatusSubtitle, FileStatusTitle } from "@air/feature-file-status/ui";
import { Close, Refresh } from "@air/next-icons";
import { VisuallyHidden } from "@air/primitive-visually-hidden";
import classNames from "classnames";
import { memo } from "react";
import isEqual from "react-fast-compare";
import { SHARED_PANEL_ITEM_CLASS_NAMES } from "../../constants/ClassNames";
import { FileStatusThumbnail } from "./FileStatusThumbnail";
export const FileStatusTrackingPanelListItemErrored = /*#__PURE__*/ memo((param)=>{
    let { item: { ext, title, thumbnailSource, onRowClick, previewLoader, avatar, status, disableCancel }, item, error, onCancel, onRetry } = param;
    return /*#__PURE__*/ _jsx(FileStatusPanelItem, {
        onClick: onRowClick,
        className: classNames("hover:bg-grey-3", SHARED_PANEL_ITEM_CLASS_NAMES, !!onRowClick && "cursor-pointer"),
        previewLoader: previewLoader,
        avatar: avatar !== null && avatar !== void 0 ? avatar : /*#__PURE__*/ _jsx(FileStatusThumbnail, {
            ext: ext,
            status: status,
            thumbnailSource: thumbnailSource
        }),
        title: /*#__PURE__*/ _jsx(FileStatusTitle, {
            children: title
        }),
        subtitle: /*#__PURE__*/ _jsxs(FileStatusSubtitle, {
            className: "truncate",
            children: [
                /*#__PURE__*/ _jsxs(VisuallyHidden, {
                    children: [
                        "with ",
                        title
                    ]
                }),
                /*#__PURE__*/ _jsx("span", {
                    "aria-hidden": "true",
                    children: "Error:"
                }),
                " ",
                error
            ]
        }),
        buttons: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                onRetry && /*#__PURE__*/ _jsx(FileStatusButton, {
                    onClick: ()=>onRetry(item),
                    label: "Retry",
                    children: /*#__PURE__*/ _jsx(Refresh, {
                        className: "size-4"
                    })
                }),
                onCancel && !disableCancel && /*#__PURE__*/ _jsx(FileStatusButton, {
                    onClick: ()=>onCancel(item),
                    label: "Cancel",
                    children: /*#__PURE__*/ _jsx(Close, {
                        className: "size-4"
                    })
                })
            ]
        })
    });
}, isEqual);
FileStatusTrackingPanelListItemErrored.displayName = "FileStatusTrackingPanelListItemErrored";
